// signup functionality taken from newsletter-signup.js
class BloomreachNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form', 'input', 'button']
  }

  constructor () {
    super()
    this.isSubmitting = false

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.form.exists) {
      this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
    }
  }

  async handleSubmit (event) {
    event.preventDefault()

    if (this.isSubmitting || !this.els?.input.exists) return

    const email = this.els.input.element.value.trim()

    if (!email || !this.isValidEmail(email)) {
      this.showMessage(this.errorMessage, 'error')
      return
    }

    this.setFormState('loading')
    this.isSubmitting = true

    this.bloomreachTrackEvent(email)

    this.showMessage(this.successMessage, 'success')
    this.setFormState('success')

    // Reset form after success
    setTimeout(() => {
      if (this.els?.form.exists) {
        this.els.form.element.reset()
      }
      this.clearMessage()
      this.setFormState('idle')
      this.isSubmitting = false
    }, 3000)
  }

  bloomreachTrackEvent (email) {
    window.exponea.identify(
      { email_id: email.toLowerCase().trim() },
      { email: email.toLowerCase().trim() },
    )

    window.exponea.track('consent', {
      action: 'accept',
      category: 'Marketing',
      valid_until: 'unlimited',
      message: 'This consent was tracked from newsletter section',
    })
  }

  isValidEmail (email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  get successMessage () {
    return this.els?.form.element?.dataset.successMessage || 'Thank you for subscribing!'
  }

  get errorMessage () {
    return this.els?.form.element?.dataset.errorMessage || 'Please enter a valid email address'
  }

  setFormState (state) {
    if (this.els?.form.exists) {
      this.els.form.element.setAttribute('data-state', state)
    }

    if (this.els?.button.exists) {
      this.els.button.element.disabled = state === 'loading' || state === 'success'
    }

    if (this.els?.input.exists) {
      this.els.input.element.disabled = state === 'loading' || state === 'success'
    }
  }

  showMessage (text, type = 'info') {
    this.clearMessage()

    const messageEl = document.createElement('div')
    messageEl.className = `fz-14_120 brn-BloomreachNewsletter_Message brn-BloomreachNewsletter_Message-${type}`
    messageEl.textContent = text
    messageEl.setAttribute('role', type === 'error' ? 'alert' : 'status')

    if (this.els?.form.exists) {
      const formContainer = this.els.form.element.parentElement
      if (formContainer) {
        formContainer.insertBefore(messageEl, this.els.form.element)
      }
    }
  }

  clearMessage () {
    if (!this.els?.form.exists) return

    const formContainer = this.els.form.element.parentElement
    if (!formContainer) return

    const existingMessage = formContainer.querySelector(
      '.brn-BloomreachNewsletter_Message',
    )
    if (existingMessage) {
      existingMessage.remove()
    }
  }
}

if (!customElements.get('bloomreach-newsletter')) {
  customElements.define('bloomreach-newsletter', BloomreachNewsletter)
}
